import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.js';
import { SessionProvider } from './session/session-context.js';
import { ThemeProvider, applyInitialTheme } from './shell/theme.js';
import './styles.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('admin-web.bootstrap: #root element missing from index.html');
}

// Phase 37 — apply persisted theme before paint to avoid a light-mode flash.
applyInitialTheme();

// Phase 37 — admin SPA is mounted under /admin/* by nginx (see
// infra/test/nginx-twxpanel-site.conf.template), so React Router needs the
// basename to translate browser URLs like /admin/mailcom-control-plane into
// route matches against `/mailcom-control-plane`. Without this, every admin
// URL falls through the catch-all and bounces the operator out to the public
// homepage.
ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <BrowserRouter basename="/admin">
      <ThemeProvider>
        <SessionProvider>
          <App />
        </SessionProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
